// Auto-generated skeleton for VendorAccount

export const VendorAccount: Api.VendorAccount = {
  id: 0,
  hp_id: null,
  person_id: 0,
  is_internal: false,
  created: null,
  updated: null,
};

